module.exports = __webpack_public_path__ + "static/bot500-7bdd045519378c64d568d4664bac9029.png";